import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostEnergy_imports = z.any()
export type TagsPostEnergy_imports = z.infer<typeof tagsPostEnergy_imports>

export const consumesPostEnergy_imports = z.any()
export type ConsumesPostEnergy_imports = z.infer<typeof consumesPostEnergy_imports>

export const bodyPostEnergy_imports = z.object({ "attachment": z.object({ "encoding": z.string(), "filename": z.string(), "mimetype": z.string().optional(), "file": z.any(), "type": z.string().optional() }), "provider": z.union([z.string(), z.object({ "value": z.string() })]), "buildingId": z.union([z.string(), z.object({ "value": z.string() })]), "collectionPointId": z.union([z.string(), z.object({ "value": z.string() })]).optional(), "previewFingerprint": z.union([z.string(), z.object({ "value": z.string() })]).optional(), "resolutions": z.union([z.string(), z.object({ "value": z.string() })]).optional() })
export type BodyPostEnergy_imports = z.infer<typeof bodyPostEnergy_imports>

export const responsePostEnergy_imports = z.object({ "payload": z.object({ "importId": z.string(), "provider": z.enum(["edc","solarxcloud","solarman"]), "importedCount": z.number(), "newCount": z.number(), "identicalCount": z.number(), "conflictCount": z.number(), "skippedCount": z.number(), "replacedCount": z.number(), "warnings": z.array(z.string()) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostEnergy_imports = z.infer<typeof responsePostEnergy_imports>

interface IPostEnergy_imports extends BaseMethodType {
  tags: TagsPostEnergy_imports,
  consumes: ConsumesPostEnergy_imports,
  body: BodyPostEnergy_imports,
  response: ResponsePostEnergy_imports
}
export const tagsGetEnergy_imports = z.any()
export type TagsGetEnergy_imports = z.infer<typeof tagsGetEnergy_imports>

export const querystringGetEnergy_imports = z.object({ "buildingId": z.string(), "page": z.number().gte(0).default(0), "limit": z.number().gte(1).lte(100).default(20) })
export type QuerystringGetEnergy_imports = z.infer<typeof querystringGetEnergy_imports>

export const responseGetEnergy_imports = z.object({ "payload": z.object({ "items": z.array(z.object({ "id": z.string(), "provider": z.enum(["edc","solarxcloud","solarman"]), "filename": z.string(), "targetCollectionPointId": z.union([z.string(), z.null()]), "targetCollectionPointName": z.union([z.string(), z.null()]), "createdBy": z.union([z.string(), z.null()]), "createdByName": z.union([z.string(), z.null()]), "createdAt": z.string(), "revertedAt": z.union([z.string(), z.null()]), "status": z.enum(["completed","reverted"]), "legacy": z.boolean(), "parsedCount": z.number(), "importedCount": z.number(), "newCount": z.number(), "identicalCount": z.number(), "conflictCount": z.number(), "skippedCount": z.number(), "replacedCount": z.number(), "warningCount": z.number() })), "total": z.number(), "page": z.number(), "limit": z.number() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetEnergy_imports = z.infer<typeof responseGetEnergy_imports>

interface IGetEnergy_imports extends BaseMethodType {
  tags: TagsGetEnergy_imports,
  querystring: QuerystringGetEnergy_imports,
  response: ResponseGetEnergy_imports
}
export const URL = '/energy-imports'
export const validation = {
  post: {
    tags: tagsPostEnergy_imports,
    consumes: consumesPostEnergy_imports,
    body: bodyPostEnergy_imports,
    response: responsePostEnergy_imports
  },
  get: {
    tags: tagsGetEnergy_imports,
    querystring: querystringGetEnergy_imports,
    response: responseGetEnergy_imports
  }
}
export interface Energy_imports extends BaseRouteType {
  post: IPostEnergy_imports,
  get: IGetEnergy_imports
}